import Vue from "vue";
import VueI18n from "vue-i18n";
import { currentLocale, FALLBACK_LOCALE, ROOT_LOCALE } from "@/core/locale";

Vue.use(VueI18n);

// Message keys are the Hungarian texts. Other languages fall back to English,
// and as a last resort to the (Hungarian) key itself.
const i18n = new VueI18n({
    locale: currentLocale,
    fallbackLocale: FALLBACK_LOCALE,
    messages: {},
    silentTranslationWarn: true,
    silentFallbackWarn: true
});

function apiUrl() {
    return process.env.NODE_ENV === "production"
        ? `${process.env.VUE_APP_API_URL}`
        : "";
}

function fetchMessages(locale) {
    return fetch(`${apiUrl()}/translation/${locale}`)
        .then(response => (response.ok ? response.json() : {}))
        .then(messages => i18n.setLocaleMessage(locale, messages || {}))
        .catch(() => {});
}

// Loads the UI texts of the current language and its fallback.
export function loadMessages() {
    const locales = [currentLocale];
    // Hungarian keys are already Hungarian text: never fall back to English there.
    if (currentLocale !== FALLBACK_LOCALE && currentLocale !== ROOT_LOCALE) {
        locales.push(FALLBACK_LOCALE);
    }
    return Promise.all(locales.map(fetchMessages));
}

export default i18n;
